import { IParamsToSend } from '@base/@types/providers/Budget/store'

export const reportRequest: IParamsToSend = {
  empresa: {
    ids: [],
    agrupar: true
  },
  categoriaCompacta: {
    ids: [],
    agrupar: false
  },
  ano: {
    ids: [],
    agrupar: true
  },
  mes: {
    ids: [],
    agrupar: false
  },
  historico: {
    ids: [],
    agrupar: true
  },
  operacao: {
    ids: [],
    agrupar: false
  },
  loja: {
    ids: [],
    agrupar: true
  }
}
